// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import type { RootState, SeoInformationSlice } from "redux/types";
import { SeoInformation } from "interfaces/searchPage/seoInformations";

// Defaults
export const initialState: SeoInformationSlice = {
	seoInformations: [],
	seoInfoPage: {}
};

// Slice
export const seoInformationsSlice = createSlice({
	name: "SEO_INFORMATIONS",
	initialState,
	reducers: {
		setSeoInformations: (state, action: PayloadAction<SeoInformation[]>) => {
			return { ...state, seoInformations: action.payload };
		},
		setSeoInfoPage: (state, action: PayloadAction<Partial<SeoInformation>>) => {
			return { ...state, seoInfoPage: action.payload };
		}
	}
});

// Actions
export const { setSeoInformations, setSeoInfoPage } = seoInformationsSlice.actions;

// Selector
export const seoInformationsSelector = (state: RootState): SeoInformation[] => state.seoInformations.seoInformations;
export const seoInfoPageSelector = (state: RootState): Partial<SeoInformation> => state.seoInformations.seoInfoPage;

// Reducers
export default seoInformationsSlice.reducer;
